import { StringSelectionFieldDefinition } from '@fsx/fsx-shared';
import { FieldDefinition } from '../types';

type RequiredTypes = StringSelectionFieldDefinition;

export function hasMaxAllowed(
  fieldDefinition: FieldDefinition
): fieldDefinition is RequiredTypes {
  return (fieldDefinition as RequiredTypes).maxAllowed !== undefined;
}
